/**
 * Skeleton shimmer (design system, FOUNDATION).
 * Global loading rule (screens.md): skeletons matching the layout — never
 * spinners-on-white. >5 s → the caller adds the ©errors.slow line.
 */
import type { CSSProperties } from "react";

export interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  radius?: number | string;
  className?: string;
  style?: CSSProperties;
}

export function Skeleton({ width = "100%", height = 16, radius, className, style }: SkeletonProps) {
  return (
    <div
      className={`skeleton${className ? ` ${className}` : ""}`}
      style={{ width, height, borderRadius: radius, ...style }}
      aria-hidden="true"
    />
  );
}
